import Cookies from 'js-cookie';

const firstLandedGIKPageKey = 'firstLandedGIKPage';
const claimedEventIdBeforeLoggedInKey = 'claimedEventIdBeforeLoggedIn';
const claimedEventStartDateBeforeLoggedInKey = 'claimedEventStartDateBeforeLogged';
const claimedEventMonthBeforeLoggedInKey = 'claimedEventMonthBeforeLoggedIn';
const lastAccessedGIKPageKey = 'lastAccessedGIKPageKey';

export const markFirstLandedGIKPage = (pageRouteId: string) => {
  if (!Cookies.get(firstLandedGIKPageKey)) {
    Cookies.set(firstLandedGIKPageKey, pageRouteId);
  }
};

export const markClaimedEventIdBeforeLoggedIn = (eventId: string) => {
  if (eventId) {
    localStorage.setItem(claimedEventIdBeforeLoggedInKey, eventId);
  } else {
    localStorage.removeItem(claimedEventIdBeforeLoggedInKey);
  }
};

export const markClaimedEventStartDateBeforeLoggedIn = (date: string) => {
  if (date) {
    localStorage.setItem(claimedEventStartDateBeforeLoggedInKey, date);
  } else {
    localStorage.removeItem(claimedEventStartDateBeforeLoggedInKey);
  }
};

export const markClaimedEventMonthBeforeLoggedIn = (calendarDate: string) => {
  if (calendarDate) {
    localStorage.setItem(claimedEventMonthBeforeLoggedInKey, calendarDate);
  } else {
    localStorage.removeItem(claimedEventMonthBeforeLoggedInKey);
  }
};

export const getFirstLandedGIKPage = () => {
  return Cookies.get(firstLandedGIKPageKey);
};

export const getLastAccessedGIKPage = () => {
  return localStorage.getItem(lastAccessedGIKPageKey);
};

export const getClaimedEventIdBeforeLoggedIn = () => {
  return localStorage.getItem(claimedEventIdBeforeLoggedInKey);
};

export const getClaimedEventMonthBeforeLoggedIn = () => {
  return localStorage.getItem(claimedEventMonthBeforeLoggedInKey);
};

export const getClaimedEventStartDateBeforeLoggedIn = () => {
  return localStorage.getItem(claimedEventStartDateBeforeLoggedInKey);
};
